import {
  Button,
  Col,
  Form,
  Input,
  Row,
  theme,
  Image,
  Typography,
  message,
} from "antd";
import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router";
import UserContext from '../../../Contexts/UserContext';
import { colors } from "../../../AdminPortal/utils/colors";
import logo from "../../../../assets/logo.png";
import { isMobile } from "react-device-detect";
import axios from "axios";
import { BASE_URL } from '../../../Constants/EnvironmentVariableProvider';
import { RoutesLookup } from '../../../Routes/RoutesLookup';
import { USER_ROLE } from '../../../Constants/ApplicationConstants';
import { getRoleFromAuth } from '../../../../utils/commonUtils';

const { Title } = Typography;

const AgentSetNewPassword = () => {
  const { auth, setAuth } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const email = params?.email;
  const { token } = theme.useToken();
  const colorBgLoginLayout = token['colorBgLoginLayout']

  useEffect(() => {
    if (auth?.token && getRoleFromAuth(auth) !== USER_ROLE.ADMIN) {
      navigate(RoutesLookup.AGENT_DASHBOARD);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [setNewPasswordForm] = Form.useForm();

  const loginUser = async (values) => {
    const userData = {
      Email: email,
      Password: values.password,
    };
    if (values.password !== values.confirmPassword) {
      message.error("Passwords does't match");
    } else {
      setLoading(true);
      let url = `${BASE_URL}${RoutesLookup.UPDATE_PASSWORD}`;
      await axios
        .post(url, userData)
        .then((res) => {
          if (res?.data?.success) {
            setAuth(res?.data);
            setLoading(false);
            message.success("Password update successfully.");
            setNewPasswordForm.resetFields();

            navigate(`/agent${RoutesLookup.LOGIN}`);
          } else {
            message.error(`${res?.data?.message}`);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.log("error in agent set new password", error.message);
        })
        .finally(() => setLoading(false));
    }
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          verticalAlign: "middle",
          alignItems: "center",
        }}
      >
        <div
          style={{
            background: colorBgLoginLayout,
            width: "55%",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            display: isMobile ? "none" : "flex",
          }}
        >
          <div>
            <Image
              style={{
                marginBottom: 20,
                width: "357px",
                height: "53px",
                objectFit: "cover",
              }}
              preview={false}
              src={logo}
            />
          </div>
        </div>
        <div
          style={{
            width: isMobile ? "100%" : "45%",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div style={{ width: 350 }}>
            <div>
              <Title
                level={3}
                style={{
                  marginBottom: 15,
                  marginTop: 0,
                  color: colors.grey900,
                }}
              >
                Enter New Password
              </Title>
              <div
                style={{
                  width: "365px",
                  height: "43px",
                  marginBottom: "44px",
                  color: "#737373",
                }}
              >
                Please Enter Your New Password
              </div>
            </div>
            <Form
              form={setNewPasswordForm}
              layout="vertical"
              onFinish={loginUser}
            >
              <div>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      type: "string",
                      message: "Please enter password",
                    },
                  ]}
                >
                  <Input.Password
                    style={{
                      height: 42,
                      border: `1px solid ${colors.grayNeutral300}`,
                    }}
                    autoComplete="off"
                    size="large"
                  />
                </Form.Item>
                <Form.Item
                  label="Confirm Password"
                  name="confirmPassword"
                  rules={[
                    {
                      required: true,
                      type: "string",
                      message: "Please enter confirm password",
                    },
                  ]}
                >
                  <Input.Password
                    style={{
                      height: 42,
                      border: `1px solid ${colors.grayNeutral300}`,
                    }}
                    autoComplete="off"
                    size="large"
                  />
                </Form.Item>
              </div>
              <Row style={{ marginTop: 28 }}>
                <Col span={24}>
                  <Button
                    loading={loading}
                    block
                    type="primary"
                    htmlType="submit"
                    size="large"
                  >
                    Continue
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AgentSetNewPassword;
